module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/orders/girls_2-48bc8c233eee376c0d510c2c48370784.jpg";